export { default, getServerSideProps } from './App';
